<template>
  <div>
    <el-table
      v-loading="loading"
      size="medium"
      stripe
      :data="transactions"
      style="width: 100%"
    >
      <!--  -->
      <el-table-column align="center" label="#ID" width="60">
        <template #default="scope">
          <el-tooltip :content="scope.row._id">
            <i f-w-700 class="el-icon-money"></i>
          </el-tooltip>
        </template>
      </el-table-column>
      <!-- Who paid -->
      <el-table-column prop="Startup" label="Startup" width="180">
        <template #default="scope">
          <h4 f-w-600 m-tb-0>{{ scope.row.business.name }}</h4>
        </template>
      </el-table-column>
      <!-- Talent -->
      <el-table-column prop="Talent" label="Talent" width="180">
        <template #default="scope">
          <h4 f-w-600 m-tb-0>
            {{ scope.row.talent.firstName }}
            <span v-if="scope.row.talent.lastName">
              {{ scope.row.talent.lastName.charAt(0) }}
            </span>
          </h4>
        </template>
      </el-table-column>
      <!--  -->
      <!--  -->
      <!-- amount -->
      <el-table-column label="Amount" align="right" width="130">
        <template #default="scope">
          {{ currencySign(scope.row.currency) }} {{ scope.row.amount }}
        </template>
      </el-table-column>
      <!-- boost -->
      <!-- <el-table-column label="Boost" align="right" width="100">
        <template #default="scope">
          {{ scope.row.boost * 100 }}
        </template>
      </el-table-column> -->
      <!--  -->
      <!-- Status -->
      <el-table-column align="center" label="Status">
        <template #default="scope">
          <el-tag
            :type="
              scope.row.status === 'admin'
                ? 'danger'
                : scope.row.status === 'talent'
                ? 'info'
                : 'success'
            "
            effect="dark"
            is-rounded
            size="mini"
          >
            {{ $filters.capitalize(scope.row.status) }}
          </el-tag>
        </template>
      </el-table-column>
      <!--  -->
      <!-- Created AT -->
      <el-table-column label="Created At" align="left" width="150">
        <template #default="scope">
          <small mute-secondary>
            {{ $filters.capitalize($moment(scope.row.createdAt).fromNow()) }}
          </small>
        </template>
      </el-table-column>
      <!--  -->
    </el-table>
  </div>
</template>

<script lang="ts">
import { User } from "@/shared";
import { Options, Vue } from "vue-class-component";
import { Prop } from "vue-property-decorator";

const currencyList = {
  gbp: "£",
  usd: "$",
  eur: "€",
};
@Options({
  components: {},
})
export default class extends Vue {
  @Prop({ type: Object })
  transactions?: Array<User>;

  @Prop({ type: Boolean })
  loading?: boolean;
  /**
   * @param c
   */
  currencySign(c: string) {
    return currencyList[c];
  }
}
</script>

<style lang="scss"></style>
